"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EquipmentService = void 0;
var _environment = require("../environment");
var _http = require("./http");
var _user = require("./user");
class EquipmentService {
  static async getBicycles() {
    if (!_user.UserService.currentUser) throw new Error('user not connected');
    try {
      const {
        results
      } = await _http.HttpService.get('v1', `/bicycles`);
      return results.map(parseBicycle);
    } catch (err) {
      console.error('[EquipmentService][getBicycles]', err);
      throw err;
    }
  }
  static async addBicycle({
    isDefault,
    nickname,
    purchaseDate,
    totalDistance: total_distance_km,
    selectedModel,
    newPhotos: newPhotosFiles
  }) {
    if (!_user.UserService.currentUser) throw new Error('user not connected');
    const params = {
      default: isDefault,
      nickname,
      purchase_date: purchaseDate || null,
      total_distance_km,
      model_external_identifier: selectedModel ? selectedModel.id : null,
      model_external_data: selectedModel
    };
    try {
      const result = await _http.HttpService.post('v1', `/bicycles`, [], [], JSON.stringify(params));
      if (newPhotosFiles && newPhotosFiles.length > 0) {
        const newPhotos = await Promise.all(newPhotosFiles.map(async newPhoto => {
          const formData = new FormData();
          formData.append('photo', newPhoto);
          try {
            const data = await _http.HttpService.post('v1', `/bicycles/${result.id}/photos`, [], [], formData);
            return data;
          } catch (err) {
            console.error(err);
            return null;
          }
        }));
        result.photos = newPhotos.reduce((res, newPhoto) => {
          if (newPhoto) res.push(newPhoto);
          return res;
        }, []);
      }
      return parseBicycle(result);
    } catch (err) {
      console.error('[EquipmentService][addBicycle]', err);
      throw err;
    }
  }
  static async updateBicycle(bicycle, {
    isDefault,
    nickname,
    purchaseDate,
    totalDistance,
    selectedModel,
    newPhotos: newPhotosFiles,
    photosToRemove
  }) {
    if (!_user.UserService.currentUser) throw new Error('user not connected');
    let updatedBicycle = {
      ...bicycle
    };
    let updatedPhotos = [...bicycle.photos];
    if (newPhotosFiles && newPhotosFiles.length > 0) {
      const newPhotos = await Promise.all(newPhotosFiles.map(async newPhoto => {
        const formData = new FormData();
        formData.append('photo', newPhoto);
        try {
          const data = await _http.HttpService.post('v1', `/bicycles/${bicycle.id}/photos`, [], [], formData);
          return data;
        } catch (err) {
          console.error(err);
          return null;
        }
      }));
      updatedPhotos.push(...newPhotos.reduce((res, newPhoto) => {
        if (newPhoto) res.push({
          id: newPhoto.id,
          url: `${_environment.defaultEnvironment.backendUrl}${newPhoto.photo}`
        });
        return res;
      }, []));
    }
    if (photosToRemove && photosToRemove.length > 0) {
      const succeeded = await Promise.all(photosToRemove.map(async id => {
        try {
          const data = await _http.HttpService.delete('v1', `/bicycles/${bicycle.id}/photos/${id}`);
          return data;
        } catch (err) {
          console.error(err);
          return false;
        }
      }));
      const removedPhotos = succeeded.map((success, index) => success ? photosToRemove[index] : null).reduce((res, id) => {
        if (id) res.push(id);
        return res;
      }, []);
      updatedPhotos = updatedPhotos.filter(({
        id
      }) => !removedPhotos.includes(id));
    }
    const params = {};
    if (isDefault !== undefined) params.default = isDefault;
    if (nickname !== undefined) params.nickname = nickname;
    if (purchaseDate) params.purchase_date = purchaseDate;
    if (totalDistance !== undefined) params.total_distance_km = totalDistance;
    if (selectedModel) {
      params.model_external_identifier = selectedModel.id;
      params.model_external_data = selectedModel;
    } else if (selectedModel === null) {
      params.model_external_identifier = null;
      params.model_external_data = null;
    }
    try {
      if (Object.keys(params).length > 0) {
        const result = await _http.HttpService.patch('v1', `/bicycles/${bicycle.id}`, [], [], JSON.stringify(params));
        updatedBicycle = parseBicycle(result);
      }
      updatedBicycle.photos = updatedPhotos;
      return updatedBicycle;
    } catch (err) {
      console.error('[EquipmentService][updateBicycle]', err);
      throw err;
    }
  }
  static async deleteBicycle(bicycleId) {
    if (!_user.UserService.currentUser) throw new Error('user not connected');
    try {
      await _http.HttpService.delete('v1', `/bicycles/${bicycleId}`);
      return true;
    } catch (err) {
      console.error('[EquipmentService][deleteBicycle]', err);
      throw err;
    }
  }
  static async getExternalModels({
    search
  }) {
    try {
      const results = await _http.HttpService.get('v1', `/external_bicycle_models`, [{
        key: 'search',
        value: search
      }, {
        key: 'autocomplete',
        value: true
      }]);
      return results;
    } catch (err) {
      console.error('[EquipmentService][getExternalModels]', err);
      throw err;
    }
  }
}
exports.EquipmentService = EquipmentService;
function parseBicycle({
  color,
  default: isDefault,
  id,
  model,
  nickname,
  photos,
  power_type,
  purchase_date,
  total_distance_km: totalDistance
}) {
  const powerType = power_type === 'ELECTRIC_ASSISTANCE' ? 'electricAssistance' : power_type === 'SPEED_BICYCLE' ? 'speedBike' : 'muscular';
  return {
    brand: model?.brand || null,
    color,
    id,
    isDefault,
    model: model ? {
      id: model.id_99_spokes,
      title: model.title,
      photo: `${_environment.defaultEnvironment.backendUrl}${model.photo}`,
      powerType,
      year: model.year
    } : null,
    nickname,
    photos: photos?.map(({
      id,
      photo
    }) => ({
      id,
      url: `${_environment.defaultEnvironment.backendUrl}${photo}`
    })) || [],
    powerType,
    purchaseDate: purchase_date ? new Date(purchase_date) : null,
    totalDistance
  };
}